import { getEventEmitter } from '@flixbus/transclusion-eventing';

export const EVENT_SEARCH_FOR_STATIONS = 'search.search-mask.station_searched';

export const emitSearchForStationEvent = () => {
  const eventEmitter = getEventEmitter();

  eventEmitter.emit(EVENT_SEARCH_FOR_STATIONS);
};
